import '../assets/styles/desktop.scss';
import { ReactComponent as AppleStoreLogo } from '../assets/images/apple_store.svg';
import { ReactComponent as GooglePlayLogo } from '../assets/images/google_play.svg';

export default function DesktopPcOnlyPage() {
  return (
    <section className="container">
      <p>
        <b>🏖️ 수영장 예약은 앱 전용 서비스입니다!</b>
      </p>
      <p>
        지금 보고 계신 페이지에서는 평상 예약이 불가하며,
        <br />
        모든 예약 및 이벤트 참여는 [야옹상회 앱]에서만 가능합니다.
      </p>
      <p>
        📱 <b>앱 설치 시 이런 혜택이 있어요!</b>
      </p>
      <p>
        ✔️ 빠르고 간편한 평상 예약
        <br />
        ✔️ <b>간식만 줘도 자동 응모!</b> 매주 100명 추첨
        <br />
        ✔️ 평상, 입장권, 피자, 아이스아메리카노, 스타벅스 콜드컵, 포인트 등 풍성한 상품
        <br />
        ✔️ 예약 내역, 쿠폰 확인, 사용까지 앱에서 한 번에
        <br />
        ✔️ 앱 전용 간식 게임, 포인트 미션, 미니게임으로 기프티콘 교환 가능
      </p>
      <p>
        🎁 <b>간식만 줘도 매주 공짜 수영장 찬스!</b>
        <br />
        지금 앱 설치하고, 놓치면 아쉬운 여름 한정 혜택에 참여하세요!
        <br />
        <b>야옹상회의 모든 기능은 앱에서만 제공됩니다.</b>
      </p>
      <div className="delimiter" />
      <p>
        📥 <b>지금 바로 앱을 설치하고, 원하는 날짜의 평상을 미리 예약해보세요!</b>
        <br />
        놓치면 아쉬운 여름 한정 혜택, 지금 시작하세요!
      </p>
      {/* <p>
        <span>🐾 야옹상회 이용 및 송추 히든밸리 수영장 예약은 앱에서만 이용할 수 있어요!</span>
      </p>
      <p>수영장 평상 예약하고 더 많은 고양이 친구들이 주는 포인트 보상을 만나려면</p>
      <p>
        <span>지금 야옹상회 앱을 설치해보세요!</span>
      </p>
      <p>
        <span>앱 전용 서비스 안내</span>
      </p>
      <p>• 송추 히든밸리 수영장 평상 예약도 앱에서만 제공돼요.</p>
      <p>•출석체크, 럭키스핀, 토리를 구해줘 미니게임, 에그 부화 미니게임,</p>
      <p>
        도감 수집, 간식 타이밍 맞추기 등 모든 기능은 <span>앱에서만 제공돼요.</span>
      </p>
      <p>•웹에서는 더 이상 야옹상회를 이용하실 수 없어요 😿 </p> */}
      <p className="font-big">📱 아래 버튼을 눌러 앱을 다운로드해 주세요!</p>
      <div className="buttons">
        <div className="btn_container">
          <a
            href="#"
            onClick={() => {
              window.location.href = 'https://play.google.com/store/apps/details?id=com.yaong.app';
            }}
          >
            <GooglePlayLogo />
          </a>
          <a
            href="#"
            onClick={() => {
              window.location.href =
                'https://apps.apple.com/kr/app/%EC%95%BC%EC%98%B9%EC%83%81%ED%9A%8C-%EC%89%BD%EA%B3%A0-%EC%A6%90%EA%B1%B0%EC%9A%B4-%ED%8F%AC%EC%9D%B8%ED%8A%B8-%EB%A6%AC%EC%9B%8C%EB%93%9C%EC%95%B1-%EC%95%B1%ED%85%8C%ED%81%AC/id6502283766';
            }}
          >
            <AppleStoreLogo />
          </a>
        </div>
      </div>
    </section>
  );
}
